import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";

export const GET_EARNINGS_DATA = 'GET_EARNINGS_DATA';
export const GET_EARNINGS_DATA_SUCCESS = 'GET_EARNINGS_DATA_SUCCESS';
export const GET_EARNINGS_DATA_FAILED = 'GET_EARNINGS_DATA_FAILED';

export const GET_EARNINGS_CSV = 'GET_EARNINGS_CSV';
export const GET_EARNINGS_CSV_SUCCESS = 'GET_EARNINGS_CSV_SUCCESS';
export const GET_EARNINGS_CSV_FAILED = 'GET_EARNINGS_CSV_FAILED';

export const SHOW_ALERT_EARNINGS = "SHOW_ALERT_EARNINGS";
export const HIDE_ALERT_EARNINGS = "HIDE_ALERT_EARNINGS"

export function fetchShowAlertEarnings() {
  return {
      type: SHOW_ALERT_EARNINGS,
  }
}

export function hideAlertEarnings(){
  return {
      type: HIDE_ALERT_EARNINGS
  }
}

export function triggerFetchEarnings(obj) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}earnings`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_EARNINGS_DATA,
            successAction: GET_EARNINGS_DATA_SUCCESS,
            failedAction: GET_EARNINGS_DATA_FAILED,
            type: "POST",
            tab:obj.tab
            // callback: obj.callback,
            // extraData: obj.extraData
        }
        makeAPICall(params);
    }
}

export function triggerFetchEarningsCSV(obj,callback) {
    return dispatch => {
        const params = {
            url: `${config.apiBasePath.baseIp}earningsCSV`,
            dispatch,
            params: obj.params,
            headers: obj.headers,
            defaultAction: GET_EARNINGS_CSV,
            successAction: GET_EARNINGS_CSV_SUCCESS,
            failedAction: GET_EARNINGS_CSV_FAILED,
            type: "POST",
            callback: callback,
            tab:obj.tab
            // extraData: obj.extraData
        }
        makeAPICall(params);
    }
}
